type Span = { top: number; bottom: number };
type View = { scrollTop: number; height: number };

export const revealScrollTop = (option: Span, view: View, room: number): number => {
  if (option.bottom + room > view.scrollTop + view.height) return option.bottom + room - view.height;
  if (option.top - room < view.scrollTop) return Math.max(0, option.top - room);
  return view.scrollTop;
};

export const scrollTopRevealing = (list: HTMLElement, option: HTMLElement): number =>
  revealScrollTop(
    { top: option.offsetTop, bottom: option.offsetTop + option.offsetHeight },
    { scrollTop: list.scrollTop, height: list.clientHeight },
    parseFloat(getComputedStyle(list).paddingTop) || 0
  );
